<template>
<div class="EarnPage">
<div class="earnRsBox" :style="{backgroundImage:'url('+require('../../assets/images/invite/earnRsBg.png')+')'}">
  <div class="title" v-html="getEarnRsTitle($t('lang.invitee.earnRsTitle'))"></div>
  <div class="invitationLink">{{$t('lang.invitee.invitationLink')}}</div>
  <div class="linkBox">
    <div class="link">{{linkUrl}}</div>
    <div class="copyBtn" @click="copyLinkClick">{{$t('lang.invitee.copy')}}</div>
  </div>
  <div class="shareViaSocials">{{$t('lang.invitee.shareViaSocials')}}</div>
  <div class="sharBox">
    <div class="itemBox" @click="whatsappClick()">
      <img src="../../assets/images/invite/ic_whatsapp.png" alt="" class="icon">
      <div class="label">{{$t('lang.invitee.whatsapp')}}</div>
    </div>
    <div class="itemBox" @click="instagramClick()">
      <img src="../../assets/images/invite/ic_Instagram.png" alt="" class="icon">
      <div class="label">{{$t('lang.invitee.instagram')}}</div>
    </div>
    <div class="itemBox" @click="telegramClick()">
      <img src="../../assets/images/invite/ic_telegram.png" alt="" class="icon">
      <div class="label">{{$t('lang.invitee.telegram')}}</div>
    </div>
    <div class="itemBox" @click="facebookClick()">
      <img src="../../assets/images/invite/ic_facebook.png" alt="" class="icon">
      <div class="label">{{$t('lang.invitee.facebook')}}</div>
    </div>
  </div>
</div>
  <div class="totalFundsBox" :style="{height:totalFundsBoxHeight + 'vw'}">
    <div class="noneMarsk" @click="handelOpenChat" v-if="pageData.reardConfig && pageData.reardConfig.InviterIsInvalid">
      <div class="descriptionBox">
        <img src="../../assets/images/invite/noneIcon.png" class="noneIcon">
        <div class="noneDescription">{{$t('lang.invitee.noneDescription')}}</div>
      </div>
      <div class="cuslomerServiceBtn">{{$t('lang.invitee.cuslomerService')}}</div>
    </div>
    <img src="../../assets/images/invite/totalFundsBg.png" alt="" class="bg">
    <img @click="openTotalFundsBox()" src="../../assets/images/invite/selectIcon.png" alt="" class="selectIcon"
         :class="{ 'rotate-icon': totalFundsBoxHeight === 71 }" style="">
    <div class="myTotalFunds">
      {{$t('lang.invitee.myTotalFunds')}}
<!--    <div class="tag" :style="{backgroundImage:'url('+require('../../assets/images/invite/totalRewardsTagBg.png')+')'}"> {{$t('lang.invitee.toWithdrawableBalance')}}</div>-->
    </div>
    <div class="bonusBox">
      <div class="bonus">₹ {{pageData?(pageData.uncollectReward?pageData.uncollectReward.Total : '') : ''}}</div>
      <div :class="pageData.uncollectReward && pageData.uncollectReward.Total > 0 ?'claimBtn' : 'claimBtnNone'" @click="collectReward()">{{$t('lang.invitee.claim')}}</div>
    </div>
    <div class="myTotalFundsTip" @click="openTotalFundsBox()">{{$t('lang.invitee.myTotalFundsTip')}}</div>
    <div class="commissionBox">
      <div class="rowBox">
        <div class="rowItem">
          <div class="label">{{$t('lang.invitee.BetCommission')}}</div>
          <div class="bonus">₹ {{pageData.uncollectReward ? pageData.uncollectReward.BetCommission : 0}}</div>
        </div>
        <div class="rowItem">
          <div class="label">{{$t('lang.invitee.DepositCommission')}}</div>
          <div class="bonus">₹ {{pageData.uncollectReward ? pageData.uncollectReward.DepositCommission : 0}}</div>
        </div>
      </div>
      <div class="bonudTip">
        <img src="../../assets/images/invite/bonudTip.png" class="bonudTipIcon" alt="">
        {{$t('lang.invitee.bonudTip')}}
      </div>
      <div class="rowBox">
        <div class="rowItem2">
          <div class="labelBox">
            <div class="label">{{$t('lang.invitee.newValidInvitees')}}</div>
            <div class="tip">Get Your Reward Instantly When Your Invitee Makes Their First Deposit</div>
          </div>
          <div class="bonus">₹ {{pageData.uncollectReward ? pageData.uncollectReward.Capitation : 0}}</div>
        </div>
      </div>
<!--      <div class="commission">-->
<!--        <div class="label">{{$t('lang.invitee.BetCommission')}}</div>-->
<!--        <div class="bonus">₹ {{pageData.uncollectReward ? pageData.uncollectReward.BetCommission : 0}}</div>-->
<!--      </div>-->
<!--      <div class="commission">-->
<!--        <div class="label">{{$t('lang.invitee.DepositCommission')}}</div>-->
<!--        <div class="bonus">₹ {{pageData.uncollectReward ? pageData.uncollectReward.DepositCommission : 0}}</div>-->
<!--      </div>-->
<!--      <div class="commission">-->
<!--        <div class="label">{{$t('lang.invitee.newValidInvitees')}}</div>-->
<!--        <div class="bonus">₹ {{pageData.uncollectReward ? pageData.uncollectReward.Capitation : 0}}</div>-->
<!--      </div>-->
    </div>
  </div>
  <div class="invitationCampaignBg" v-if="pageData.reardConfig && (pageData.reardConfig.VirIsOpen || pageData.reardConfig.InviteRankIsOpen)">
    <img src="../../assets/images/invite/invitationCampaignTitleIcon.png" alt="" class="invitationCampaignIcon">
    <div class="title">{{$t('lang.invitee.invitationCampaign')}}</div>
<!--    -->
    <div class="cashWheelBox"  :style="{backgroundImage:'url('+require('../../assets/images/invite/invitationCampaignItemBg.png')+')'}" v-if="pageData.reardConfig && pageData.reardConfig.VirIsOpen">
      <img src="../../assets/images/invite/cashWheelImg.png" alt="" class="rightImg">
      <div class="title" v-html="getCashWhellClaimBonus($t('lang.invitee.claimBonus'))"></div>
      <div class="activityName">{{$t('lang.invitee.activityNameCashWheel')}}</div>
      <div class="cashWheelTip">{{$t('lang.invitee.cashWheelTip')}}</div>
      <div class="viewDetailBtn" @click="goCashWheel()">{{$t('lang.invitee.viewDetail')}}</div>
    </div>
<!--    -->
    <div class="leaderboardBox" :style="{backgroundImage:'url('+require('../../assets/images/invite/invitationCampaignItemBg.png')+')'}" v-if="pageData.reardConfig && pageData.reardConfig.InviteRankIsOpen">
      <img src="../../assets/images/invite/leaderboardImg.png" alt="" class="rightImg">
      <div class="title" v-html="getLeaderboarClaimBonus($t('lang.invitee.claimBonus'))"></div>
      <div class="activityName">{{$t('lang.invitee.activityNameInviteLeaderboard')}}</div>
      <div class="cashWheelTip">{{$t('lang.invitee.LeaderboardTip')}}</div>
      <div class="viewDetailBtn" @click="goShareFiesta()">{{$t('lang.invitee.viewDetail')}}</div>
    </div>
  </div>
  <div @click="outLink" class="followChannel" :style="{backgroundImage:'url('+require('../../assets/images/invite/followChannelBg.png')+')'}">
    <div class="leftBox">
      <img src="../../assets/images/invite/addIcon.png" alt="" class="addIcon">
      <div class="label">{{$t('lang.invitee.followChannel')}}</div>
    </div>
    <img src="../../assets/images/invite/followChannelIcon.png" alt="" class="icon">
  </div>
</div>
</template>

<script>
import request from '@/service'
import {Toast} from 'mint-ui'
import {LogUtils} from '@/utils'
export default {
  name: 'EarnPage',
  props: ['pageData', 'shareCodeData', 'linkUrl'],
  data () {
    return {
      shareCode: '',
      totalFundsBoxHeight: 32,
      userInfo: JSON.parse(localStorage.getItem('userInfo'))
    }
  },
  watch: {
    shareCodeData: {
      handler (val) {
        this.shareCode = val
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {
    handelOpenChat () {
      if (this.userInfo && this.userInfo.UserShowId) {
        window.LiveChatWidget.call('set_customer_name', this.userInfo.UserShowId)
      } else {
        window.LiveChatWidget.call('set_customer_name', ' ')
      }
      window.LiveChatWidget.call('maximize')
    },
    goCashWheel () {
      this.$router.push('/cashWheel')
      this.saveUserEvent('inviteGoVIR')
    },
    goShareFiesta () {
      if (!this.userInfo) {
        this.$router.push('/Login')
      } else {
        this.$router.push('/ShareFiesta')
        this.saveUserEvent('inviteGoShareFiesta')
      }
    },
    outLink () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      window.location.href = 'https://t.me/+y6Swf0yJaNY0NWVl'
    },
    saveUserEvent (val) {
      const url = '/innovation/account/save/user/event'
      const data = {EventNameEN: val, UserUniqueId: this.userInfo ? this.userInfo.UserId : ''}
      request('post', url, data).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
    telegramClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Telegram')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://t.me/share/url?text=` + message + `&url=%20`)
    },
    whatsappClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('WhatsApp')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      window.open(`https://wa.me/?text=${message}`, '_blank')
    },
    facebookClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.saveUserEvent('Facebook')
      this.copyShares()
      console.log(`https://www.facebook.com/sharer.php?u=${encodeURIComponent(this.shareCode)}`)
      window.open(`https://www.facebook.com/sharer.php?u=${encodeURIComponent(this.shareCode)}`, '_blank')
    },
    msgFormatFB () {
      let welcomeMessage = ''
      // Check if shareType already exists in the shareCode
      if (!this.shareCode.includes('shareType=')) {
        // Append the shareType parameter to the shareCode
        if (this.shareCode.includes('?')) {
          this.shareCode += '&shareType=EARN'
        } else {
          this.shareCode += '?shareType=EARN'
        }
      }
      welcomeMessage = `${this.shareCode} 👋Hey bro, check this out! 💰Give you ₹177 + 30 FREE CASH! 🔥Play India's hottest games and win real money!🎰`
      return welcomeMessage
    },
    async instagramClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      const shareData = {
        text: this.msgFormat()
      }
      this.saveUserEvent('Instagram')
      if (window.Android) {
        window.Android.callShareSheet(JSON.stringify(shareData))
      } else {
        if (navigator.share) {
          try {
            await navigator.share(shareData)
          } catch (e) {
          }
        } else {
          this.copyShares()
        }
      }
    },
    msgFormat () {
      let welcomeMessage = this.$t('lang.sportsBetting.shareMsg')
      let index = this.shareCode.indexOf('/Share')
      if (index === -1) {
        index = this.shareCode.toLowerCase().indexOf('/share')
      }
      welcomeMessage = welcomeMessage.replace('{shareUrl}', this.shareCode)
      return welcomeMessage
    },
    copyShares () {
      let message = this.msgFormat()
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', message)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
    },
    copyLinkClick () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.copyShares()
      this.saveUserEvent('Link2')
      Toast(this.$t('lang.inviteFriends.success'))
    },
    getEarnRsTitle (val) {
      if (this.pageData.reardConfig) {
        return val.replace('{bonus}', this.pageData.reardConfig.Capitation).replace('\n', '<br/>')
      }
    },
    getCashWhellClaimBonus (val) {
      if (this.pageData.reardConfig) {
        return val.replace('{bonus}', 5000)
      }
    },
    getLeaderboarClaimBonus (val) {
      if (this.pageData.reardConfig) {
        return val.replace('{bonus}', 3000)
      }
    },
    // 领取奖励接口
    collectReward () {
      if (this.pageData.uncollectReward && this.pageData.uncollectReward.Total <= 0) {
        return
      }
      if (this.pageData && this.pageData.uncollectReward && this.pageData.uncollectReward.Total !== 0) {
        const url = '/innovation/invite_relation/collect/reward'
        const data = {
          userId: this.userInfo.UserId || ''
        }
        request('post', url, data).then(res => {
          if (res) {
            LogUtils.logout9w()
            this.$emit('resetReard')
          }
        })
      }
    },
    openTotalFundsBox () {
      if (this.totalFundsBoxHeight === 32) {
        this.totalFundsBoxHeight = 71
      } else {
        this.totalFundsBoxHeight = 32
      }
    }
  }
}
</script>

<style lang="less" scoped>
.EarnPage{
  overflow: hidden;
  .earnRsBox{
    background-size: 100% 100%;
    height: 82vw;
    width: 95vw;
    margin-top: 14vw;
    position: relative;
    .title{
      font-size: 4.2vw;
      text-align: center;
      text-transform: capitalize;
      color: #FFFFFF;
      font-family: 'Inclusive Sans';
      font-style: normal;
      text-transform: capitalize;
      color: #FFFFFF;
      font-weight: 400;
      letter-spacing: 0.2vw;
      width: 81.488vw;
      line-height: 6.2vw;
      transform: translateX(8%);
      //background: linear-gradient(90deg, #FFFFFF 0%, #E9FFA2 100%);
      //-webkit-background-clip: text;
      //-webkit-text-fill-color: transparent;
      //background-clip: text;
      //text-fill-color: transparent;
      position: absolute;
      top: 6vw;
    }
    .invitationLink{
      font-size: 3.611vw;
      color: #fff;
      position: absolute;
      top: 27vw;
      left: 6vw;
    }
    .linkBox{
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      top: 36.5vw;
      left: 7vw;
      width: 78vw;
      .link{
        font-size: 3.2vw;
        margin-left: 1vw;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        line-height: 121.99%;
        text-transform: capitalize;
        color: #F0F0F0;
        opacity: 0.52;
        width: 65vw;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .copyBtn{
        color: #007BFF;
        font-size: 3.2vw;
        border-bottom: 1px solid;
        padding-bottom: 0.2vw;
        //margin-right: 1vw;
      }
    }
    .shareViaSocials{
      font-size: 3.611vw;
      color: #fff;
      position: absolute;
      top: 47vw;
      left: 6vw;
    }
    .sharBox{
      display: flex;
      align-items: center;
      justify-content: space-around;
      position: relative;
      top: 54vw;
      .itemBox{
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2vw;
        .icon{
          height: 20vw;
          width: 20vw;
        }
        .label{
          font-size: 2.777vw;
          color: #fff;
          font-weight: 700;
        }
      }
    }
  }
  .totalFundsBox{
    width: 95vw;
    background-size: 100% 100%;
    margin-top: 2vw;
    position: relative;
    overflow: hidden;
    border-radius: 1.666vw;
    transition: height 0.2s ease;
    .noneMarsk{
      position: absolute;
      z-index: 10;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: rgba(0,0,0,.7);
      display: flex;
      flex-direction: column;
      align-items: center;
      .descriptionBox{
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        left: 4.5vw;
        top: 7vw;
        .noneIcon{
          width: 10.208vw;
          height: 12.794vw;
        }
        .noneDescription{
          margin-left: 2vw;
          font-size: 3.444vw;
          font-weight: 700;
          color: #fff;
          width: 76vw;
          height: 12vw;
          display: flex;
          line-height: 4vw;
          align-items: center;
        }
      }
      .cuslomerServiceBtn{
        width: 85.277vw;
        height: 8.755vw;
        font-weight: 700;
        color: #fff;
        font-size: 3.5vw;
        background-color: #434849;
        border-radius: 1.5vw;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 24vw;
      }
    }
    .bg{
      position: absolute;
      top: 0;
      left: 0;
      width: 95vw;
    }
    .selectIcon{
      position: absolute;
      top: 25.7vw;
      right: 4vw;
      width: 6.33vw;
      height: 5.222vw;
      transition: transform 0.2s ease;
      transform-origin: center;
      transform: rotate(-180deg)
    }
    .rotate-icon {
      transform: rotate(0deg); /* 当totalFundsBoxHeight为100时触发 */
    }
    .myTotalFunds{
      width: 100%;
      color: #fff;
      font-weight: 700;
      font-size: 5.277vw;
      position: absolute;
      left: 4vw;
      top: 3vw;
      display: flex;
      align-items: center;
      .tag{
        color: #fff;
        width: 36.033vw;
        height: 4.261vw;
        background-size: 100% 100%;
        font-size: 2.222vw;
        text-align: center;
        line-height: 4.261vw;
        margin-left: 3.227vw;
        font-family: 'Inter';
      }
    }
    .bonusBox{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 5vw;
      position: absolute;
      top: 11.5vw;
      .bonus{
        color: #F6D9AA;
        font-weight: 700;
        font-size: 6vw;
      }
      .claimBtn{
        background-color: #EED09E;
        width: 30.122vw;
        height: 8.661vw;
        border-radius: 1.666vw;
        font-weight: 700;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 4.222vw;
      }
      .claimBtnNone{
        background-color: #5B5B5B;
        width: 30.122vw;
        height: 8.661vw;
        border-radius: 1.666vw;
        font-weight: 700;
        color: #8C8A8A;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 4.222vw;
      }
    }
    .myTotalFundsTip{
      font-size: 3.211vw;
      color: #979797;
      position: absolute;
      top: 25.9vw;
      left: 5.5vw;
      width: 81vw;
      font-weight: 300;
      font-family: 'Inter';
      font-style: normal;
    }
    .commissionBox{
      display: flex;
      flex-direction: column;
      gap: 2.5vw;
      width: 90%;
      position: absolute;
      top: 32vw;
      left: 5vw;
      .bonudTip {
        display: flex;
        align-items: center;
        gap: 1.416vw;
        font-size: 2.222vw;
        width: 100%;
        justify-content: center;
        font-weight: 300;
        .bonudTipIcon{
          flex-shrink: 0;
          width: 2.330vw;
          height: 2.48vw;
        }
      }
      .rowBox{
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 2.638vw;
        color: #CBC9C9;
        font-weight: 600;
        gap: 2.833vw;
        .rowItem{
          height: 12.35vw;
          width: 40.897vw;
          display: flex;
          flex-direction: column;
          justify-content: center;
          background-color: rgba(82, 82, 82, 0.45);
          border-radius: 2.222vw;
          padding: 4.444vw 2.222vw;
          gap: 0.919vw;
          .label{
            color: #CBC9C9;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 600;
          }
          .bonus{
            color: #F6D9AA;
            font-size: 4.166vw;
            font-weight: 600;
          }
        }
        .rowItem2{
          height: 12.35vw;
          width: 84.6277vw;
          background-color: rgba(82, 82, 82, 0.45);
          border-radius: 2.222vw;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 4.444vw 0vw;
          .labelBox {
            display: flex;
            flex-direction: column;
            gap: 1.727vw;
            margin-left: 2.222vw;
            .label{
              color: #CBC9C9;
              font-family: 'Inter';
              font-style: normal;
              font-weight: 600;
            }
            .tip{
              color: #CBC9C9;
              font-size: 1.805vw;
              opacity: 0.49;
              font-weight: 400;
            }
          }
          .bonus{
            color: #F6D9AA;
            font-size: 4.166vw;
            font-weight: 600;
            margin-right: 3.802vw;
          }
        }
      }
      .commission{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 3vw;
        width: 100%;
        height: 11.158vw;
        background-color: rgba(82, 82, 82, 0.45);
        border-radius: 2.222vw;
        .label{
          color: #CBC9C9;
          font-size: 3.211vw;
        }
        .bonus{
          color: #F6D9AA;
          font-size: 4.22vw;
          font-weight: 500;
        }
      }
    }
  }
  .invitationCampaignBg{
    width: 95vw;
    //height: 114.444vw;
    position: relative;
    padding: 0 0 22vw 0;
    top: 2vw;
    background-color: rgb(42,42,42);
    border-radius: 2.222vw;
    .invitationCampaignIcon{
      height: 3.227vw;
      width: 2.627vw;
      position: absolute;
      left: 3vw;
      top: 5.6vw;
    }
    .title{
      font-size: 5.555vw;
      font-weight: 700;
      color: #fff;
      position: absolute;
      top: 4vw;
      left: 8vw;
    }
    .cashWheelBox{
      position: relative;
      left: 1vw;
      //border: 1px solid red;
      width: 93vw;
      height: 46.555vw;
      background-size: 100% 100%;
      top: 13vw;
      .rightImg{
        position: absolute;
        right: 4vw;
        top: 4vw;
        height: 24.777vw;
        width: 24.777vw;
      }
      .title{
        font-size: 4vw;
        color: #fff;
        font-weight: 700;
        position: absolute;
        top: 5vw;
        left: 6vw;
      }
      .activityName{
        position: absolute;
        top: 12vw;
        left: 6vw;
        font-size: 3.333vw;
        color: #808080;
      }
      .cashWheelTip{
        position: absolute;
        top: 17vw;
        left: 6vw;
        font-size: 3.333vw;
        color: #D6D6D6;
        //border: 1px solid red;
        width: 54vw;
        line-height: 4vw;
      }
      .viewDetailBtn{
        width: 77vw;
        height: 10.455vw;
        background-color: rgb(67,72,73);
        border-radius: 1.666vw;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 4.2vw;
        color: #fff;
        font-weight: 500;
        position: absolute;
        top: 31vw;
        left: 7.7vw;
      }
    }
    .leaderboardBox{
      position: relative;
      left: 1vw;
      //border: 1px solid red;
      width: 93vw;
      height: 50.555vw;
      background-size: 100% 100%;
      top: 15vw;
      .rightImg{
        position: absolute;
        right: 4vw;
        top: 4vw;
        height: 24.777vw;
        width: 24.777vw;
      }
      .title{
        font-size: 4vw;
        color: #fff;
        font-weight: 700;
        position: absolute;
        top: 5vw;
        left: 6vw;
      }
      .activityName{
        position: absolute;
        top: 12vw;
        left: 6vw;
        font-size: 3.333vw;
        color: #808080;
      }
      .cashWheelTip{
        position: absolute;
        top: 17vw;
        left: 6vw;
        font-size: 3.333vw;
        color: #D6D6D6;
        //border: 1px solid red;
        width: 54vw;
        line-height: 4vw;
      }
      .viewDetailBtn{
        width: 77vw;
        height: 10.455vw;
        background-color: rgb(67,72,73);
        border-radius: 1.666vw;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 4.2vw;
        color: #fff;
        font-weight: 500;
        position: absolute;
        top: 35vw;
        left: 7.7vw;
      }
    }
  }
  .followChannel{
    width: 95vw;
    height: 17.833vw;
    position: relative;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5vw;
    padding: 0 4vw;
    .leftBox{
      display: flex;
      align-items: center;
      height: 100%;
      .addIcon{
        height: 10.944vw;
        width: 10.944vw;
      }
      .label{
        margin-left: 2vw;
        font-size: 5vw;
        color: #fff;
        font-weight: 700;
      }
    }

    .icon{
      height: 13.444vw;
      width: 13.444vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Invitee/earnPage.vue